import { InformationCircleIcon } from '@heroicons/react/24/outline';
import Modal from '../../../components/general/Modal.tsx';
import { MoneyLabel } from '../../../components/general/MoneyLabel.tsx';
import { PrimaryButton } from '../../../components/general/PrimaryButton.tsx';
import { SecondaryButton } from '../../../components/general/SecondaryButton.tsx';
import { type ScannedTotalLine } from '../utils/scannedTotals.ts';

type ApplyScannedTotalsPopupProps = {
    open: boolean;
    onClose: () => void;
    onApply: () => void;
    lines: ScannedTotalLine[];
    currency: string;
};

const EMPTY_CELL = '-';

export function ApplyScannedTotalsPopup({
    open,
    onClose,
    onApply,
    lines,
    currency,
}: ApplyScannedTotalsPopupProps) {
    const handleApply = () => {
        onApply();
        onClose();
    };

    return (
        <Modal
            open={open}
            updateOpenState={(isOpen) => {
                if (!isOpen) {
                    onClose();
                }
            }}
            title="Gescande totaalbedragen gebruiken"
            width="3xl"
        >
            <div className="space-y-6 text-gray-800">
                <div className="flex items-start gap-3 text-sm text-gray-600">
                    <InformationCircleIcon className="h-5 w-5 flex-shrink-0 text-blue-400" aria-hidden="true" />
                    <p>
                        We gebruiken het gescande totaal van elke regel als netto bedrag. Toepassen overschrijft de
                        bedragen van alle regels hieronder. Kies daarna per regel de BTW code in de editor.
                    </p>
                </div>
                <table className="w-full text-sm">
                    <thead>
                        <tr className="border-b border-gray-200 text-left text-xs text-gray-500">
                            <th className="py-2 pr-4 font-medium">Omschrijving</th>
                            <th className="py-2 pl-4 text-right font-medium whitespace-nowrap">Totaal</th>
                        </tr>
                    </thead>
                    <tbody>
                        {lines.map(line => (
                            <tr key={line.lineItemId} className="border-b border-gray-100 last:border-0">
                                <td className="py-3 pr-4">{line.description || EMPTY_CELL}</td>
                                <td className="whitespace-nowrap py-3 pl-4 text-right">
                                    <MoneyLabel value={line.totalAmount.signed_amount / 100} currency={currency} showCurrency />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <div className="flex justify-end gap-3 border-t border-gray-200 pt-6">
                    <SecondaryButton title="Annuleren" onClick={onClose} />
                    <PrimaryButton title="Toepassen" onClick={handleApply} />
                </div>
            </div>
        </Modal>
    );
}
